<template>
  <div class="flex-sb">
    <a-card style="flex:3" :title="title">
      <a-form-model ref="formDom" :rules="rules" :model="form">
        <h3>发布平台</h3>
        <a-form-model-item label="发布平台" prop="line_id" :label-col="{span: 3}" :wrapper-col="{span: 16}">
          <a-select v-model="form.line_id" allowClear show-search option-filter-prop="children" placeholder="请输入" @change="selectPlatform">
            <a-select-option v-for="item in platformList" :disabled="item.disabled" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-row>
          <a-col span="8">
            <a-form-model-item label="平台关系" prop="rank" :label-col="{span: 9}" :wrapper-col="{span: 14}">
              <a-select v-model="form.rank" allowClear show-search option-filter-prop="children" placeholder="请输入">
                <a-select-option v-for="item in INTERVIEW_RANK" :key="item.key" :value="item.value">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item :label="labelName" prop="real" :label-col="{span: 9}" :wrapper-col="{span: 14}">
              <a-input v-model.trim="form.real" placeholder="请输入" :maxLength="30" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="platformId === '1'">
          <a-col span="18">
            <a-form-model-item label="下店后3月业绩(单位万)" prop="achievement" :label-col="{span:7}" :wrapper-col="{span: 17}">
              <div class="flex-sb">
                <div v-for="(item, index) in threeMonth" :key="index">
                  <a-input v-model="item.month" placeholder="月份" style="width: 50px" /> 月
                  <a-input v-model="item.money" placeholder="万元" style="width: 50px" /> 万
                </div>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item v-if="platformId === '1'" label="单月交易额" prop="month_achievement" :label-col="{span: 3}" :wrapper-col="{span: 16}">
          <a-input v-model.trim="form.month_achievement" placeholder="请输入(单位万)" />
        </a-form-model-item>

        <h3>采访标题</h3>
        <a-form-model-item label="采访标题" prop="title" :label-col="{span: 3}" :wrapper-col="{span: 16}">
          <a-input v-model.trim="form.title" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="采访前言" prop="preface" :label-col="{span: 3}" :wrapper-col="{span: 16}">
          <a-input v-model.trim="form.preface" placeholder="请输入" type="textarea" />
        </a-form-model-item>

        <a-row>
          <a-col span="7">
            <a-form-model-item label="被采访人" prop="name" :label-col="{span: 10}" :wrapper-col="{span: 12}">
              <a-input v-model.trim="form.name" placeholder="请输入" :maxLength="20" />
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item label="采访人" prop="nickname" :label-col="{span: 7}" :wrapper-col="{span: 16}">
              <a-input v-model.trim="form.nickname" placeholder="请输入" :maxLength="20" />
            </a-form-model-item>
          </a-col>
          <!-- 编辑时才出现 且 只读 -->
          <a-col span="6" v-if="id">
            <a-form-model-item label="采访期数" prop="cover_no" :label-col="{span: 10}" :wrapper-col="{span: 14}">
              <a-input disabled v-model.trim="form.cover_no" placeholder="请输入" :maxLength="20" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item label="采访结语" prop="epilogue" :label-col="{span: 3}" :wrapper-col="{span: 16}">
          <a-input v-model.trim="form.epilogue" placeholder="请输入" type="textarea" />
        </a-form-model-item>

        <a-form-model-item label="是否置顶" prop="is_top" :label-col="{span: 3}" :wrapper-col="{span: 16}">
          <a-radio-group v-model="form.is_top">
            <a-radio v-for="item in INTERVIEW_IS_TOP" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <h3>采访图片和视频</h3>
        <a-row>
          <a-col :span="17" :offset="2">
            <ul class="flex-sb-ac">
              <li class="flex-col-t">
                <header>采访头像</header>
                <a-upload
                  accept=".jpg, .jpeg, .png"
                  :headers="{ token }"
                  :file-list="avatarList"
                  :action="`${baseURL}/public/upload-file-qi-niu`"
                  :beforeUpload="(file) => handleBeforeUpload(file, 'avatar')"
                  list-type="picture-card"
                  @preview="handlePreview"
                  @change="(data) => handleChange('avatar', data)"
                >
                  <div v-if="avatarList.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div>
                </a-upload>
                <p>建议尺寸：125 x 125</p>
              </li>
              <li class="flex-col-t">
                <header>售后采访视频图片</header>
                <a-upload
                  accept=".jpg, .jpeg, .png"
                  :headers="{ token }"
                  :file-list="indexsmallList"
                  :action="`${baseURL}/public/upload-file-qi-niu`"
                  :beforeUpload="(file) => handleBeforeUpload(file, 'indexsmall')"
                  list-type="picture-card"
                  @preview="handlePreview"
                  @change="(data) => handleChange('indexsmall', data)"
                >
                  <div v-if="indexsmallList.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div>
                </a-upload>
                <p>建议尺寸：{{ platformId === '江雀' ? '413 x 500' : (platformId === '鱼爪' ? '380 x 480' : '423 x 285') }}</p>
              </li>
              <li class="flex-col-t">
                <header>主角风采</header>
                <a-upload
                  accept=".jpg, .jpeg, .png"
                  :headers="{ token }"
                  :file-list="mienList"
                  :action="`${baseURL}/public/upload-file-qi-niu`"
                  :beforeUpload="(file) => handleBeforeUpload(file, 'mien')"
                  list-type="picture-card"
                  @preview="handlePreview"
                  @change="(data) => handleChange('mien', data)"
                >
                  <div v-if="mienList.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div>
                </a-upload>
                <p>建议尺寸：380 x 480</p>
              </li>
              <li class="flex-col-t">
                <header>手持合同</header>
                <a-upload
                  accept=".jpg, .jpeg, .png"
                  :headers="{ token }"
                  :file-list="pactList"
                  :action="`${baseURL}/public/upload-file-qi-niu`"
                  :beforeUpload="(file) => handleBeforeUpload(file, 'pact')"
                  list-type="picture-card"
                  @preview="handlePreview"
                  @change="(data) => handleChange('pact', data)"
                >
                  <div v-if="pactList.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div>
                </a-upload>
                <p>建议尺寸：380 x 480</p>
              </li>
            </ul>
          </a-col>
        </a-row>

        <a-form-model-item label="首页展示" :label-col="{span: 2}" :wrapper-col="{span: 17}">
          <ul class="flex-sb-ac">
            <li class="flex-col-t">
              <a-upload
                accept=".jpg, .jpeg, .png"
                :headers="{ token }"
                :file-list="largerList"
                :action="`${baseURL}/public/upload-file-qi-niu`"
                :beforeUpload="(file) => handleBeforeUpload(file, 'indexList_0_larger')"
                list-type="picture-card"
                @preview="handlePreview"
                @change="(data) => handleChange('indexList_0_larger', data)"
              >
                <div v-if="largerList.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    Upload
                  </div>
                </div>
              </a-upload>
              <p>大图尺寸：460 x 400</p>
            </li>
            <li class="flex-col-t">
              <a-upload
                accept=".jpg, .jpeg, .png"
                :headers="{ token }"
                :file-list="middleList"
                :action="`${baseURL}/public/upload-file-qi-niu`"
                :beforeUpload="(file) => handleBeforeUpload(file, 'indexList_1_middle')"
                list-type="picture-card"
                @preview="handlePreview"
                @change="(data) => handleChange('indexList_1_middle', data)"
              >
                <div v-if="middleList.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    Upload
                  </div>
                </div>
              </a-upload>
              <p>中图尺寸：324 x 222</p>
            </li>
            <li class="flex-col-t">
              <a-upload
                accept=".jpg, .jpeg, .png"
                :headers="{ token }"
                :file-list="smallsList"
                :action="`${baseURL}/public/upload-file-qi-niu`"
                :beforeUpload="(file) => handleBeforeUpload(file, 'indexList_2_smalls')"
                list-type="picture-card"
                @preview="handlePreview"
                @change="(data) => handleChange('indexList_2_smalls', data)"
              >
                <div v-if="smallsList.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    Upload
                  </div>
                </div>
              </a-upload>
              <p>小图尺寸：140 x 160</p>
            </li>
          </ul>
        </a-form-model-item>

        <a-form-model-item label="视频路径" prop="video_url" :label-col="{span: 3}" :wrapper-col="{span: 16}">
          <a-input v-model="form.video_url" placeholder="请输入" :maxLength="200" />
        </a-form-model-item>

        <h3>采访对话</h3>
        <template v-for="(domain, index) in form.content">
          <div class="flex wrap" :key="index">
            <div style="width: 50%">
              <a-form-model-item
                :label-col="{span: 4}"
                :wrapper-col="{span: 20}"
                label="采访人"
                :prop="'content.' + index + '.a'"
                :rules="{ required: true, message: '请输入', trigger: 'change'}"
              >
                <a-input
                  v-model.trim="domain.a"
                  placeholder="请输入提问"
                  type="textarea"
                  style="width: 100%; margin-right: 8px"
                />
              </a-form-model-item>
              <a-form-model-item
                :label-col="{span: 4}"
                :wrapper-col="{span: 20}"
                label="受访人"
                :prop="'content.' + index + '.b'"
                :rules="{ required: true, message: '请输入', trigger: 'change'}"
              >
                <a-input
                  v-model.trim="domain.b"
                  placeholder="请输入回答"
                  type="textarea"
                  style="width: 100%; margin-right: 8px"
                />
              </a-form-model-item>
            </div>
            <a-icon
              v-if="form.content.length > 1"
              class="dynamic-delete-button"
              type="minus-circle-o"
              :disabled="form.content.length === 1"
              @click="removeContent(domain)"
            />
          </div>
        </template>

        <a-form-model-item :wrapper-col="{span: 10, offset: 2}">
          <a-button type="dashed" style="width: 100%" @click="addContent">
            <a-icon type="plus" /> 添加采访栏
          </a-button>
        </a-form-model-item>

        <a-row style="margin-top: 20px">
          <a-col span="24">
            <a-form-model-item :wrapper-col="{span: 20, offset: 1}">
              <a-button :loading="submitLoading" class="mr20" type="primary" @click="handleSubmit">保 存</a-button>
              <a-button @click="$router.go(-1)">取 消</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>

      </a-form-model>
    </a-card>

    <!-- <a-card style="flex: 1;height: 300px;margin-left: 50px" title="头像">
      <div class="flex-col-t">
        <header>采访头像</header>
        <a-upload
          accept=".jpg, .jpeg, .png"
          :headers="{ token }"
          :file-list="avatarList"
          :action="`${baseURL}/public/upload-file-qi-niu`"
          :beforeUpload="(file) => handleBeforeUpload(file, 'avatar')"
          list-type="picture-card"
          @preview="handlePreview"
          @change="(data) => handleChange('avatar', data)"
        >
          <div v-if="avatarList.length < 1">
            <a-icon type="plus" />
            <div class="ant-upload-text">
              Upload
            </div>
          </div>
        </a-upload>
        <p>建议尺寸：423 x 285</p>
      </div>
    </a-card> -->
    <!-- 图片预览 -->
    <a-modal width="50%" :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
import { reactive, onMounted, computed, toRefs, watch, getCurrentInstance } from '@vue/composition-api'
import { form, rules } from './business/'
import initList from './composables/initList'
import uploadImg from './composables/uploadImg'
import token from '@/composables/token'
import compuedFun from './computed/'
import api from '@/api/'

const title = {
  Add: '添加采访',
  Edit: '编辑采访'
}

export default {
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const id = computed(() => _this.$route.params.id)

    const state = reactive({
      rules,
      loading: false,
      platformId: null, // 平台父级id
      title: title.Add,
      labelName: '商品编号',
      // 下店三月业绩
      threeMonth: [
        { month: '', money: '' },
        { month: '', money: '' },
        { month: '', money: '' }
      ],
      baseURL: process.env.VUE_APP_API_BASE_URL,
      form: JSON.parse(JSON.stringify(form)),
      submitLoading: false,
    })

    watch(() => state.threeMonth, (newVal, oldVal) => {
      if (methods.validateThree()) {
        state.form.achievement = state.threeMonth.map(o => `${o.month}_${o.money}`)
      } else {
        state.form.achievement = ''
      }
    }, { deep: true })

    onMounted(() => {
      if (id.value) {
        state.title = title.Edit
        methods.getInterview()
      }
    })

    const methods = {
      async getInterview() {
        const res = await api.detailInterview({ id: id.value })
        const data = JSON.parse(JSON.stringify(res.data?.interview))
        if (data.org.startsWith('易店无忧')) {
          state.platformId = '1'
          state.threeMonth = data.achievement.split(',').map(o => {
            const [ month, money ] = o.split('_')
            return { month, money }
          })
        }
        // 图片域名拿接口返回的域名地址
        _this.handleEchoImg(data, data.qi_niu_domains)
        state.form = data
        // 根据平台数据 筛选可修改的项
        methods.selectPlatform(state.form.line_id)
      },

      // 提交
      handleSubmit(e) {
        // if (_this.platformId === '1') {
        //   if (!methods.validateThree()) return this.$message.warning('请检查下店3月业绩是否填写完整！')
        //   state.form.achievement = state.threeMonth.map(o => `${o.month}_${o.money}`)
        // } else {
        //   state.form.achievement = ''
        //   state.form.month_achievement = ''
        // }
        if (_this.platformId !== '1') {
          state.form.achievement = ''
          state.form.month_achievement = ''
        }
        const data = JSON.parse(JSON.stringify(state.form))
        this.$refs.formDom.validate(async valid => {
          if (valid) {
            let res
            this.submitLoading = true
            if (id.value) {
              res = await api.updateInterview(data)
            } else {
              res = await api.createInterview(data)
            }
            this.submitLoading = false
            if (_this.$validate(res)) {
              this.$message.success(id.value ? '编辑成功~' : '添加成功~')
              this.$router.push('/interview/list')
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
          }
        })
      },
      removeContent(item) {
        const index = state.form.content.indexOf(item)
        if (index !== -1) {
          state.form.content.splice(index, 1)
        }
      },
      addContent() {
        state.form.content.push({
          a: '',
          b: '',
          key: Date.now()
        })
      },

      selectPlatform(type) {
        const arr = ['专利服务', '版权服务', '商标服务']
        // _this.labelName = arr.some((i) => {
        //   return _this.platformList[type].org.endsWith(i)
        // }) ? '订单编号' : '商品编号'
        if (id.value) { methods.changePlatList(type) }
        methods.handleSelectPlatform(type)
      },

      changePlatList(type) {
        const typeName = _this.platformList.find(item => item.id === type)?.org
        const typeNamePlat = typeName ? typeName.split(' > ')[0] : ''
        _this.platformList.forEach(item => {
          item.disabled = !item.org.includes(typeNamePlat)
        })
      },

      handleSelectPlatform(type) {
        if (!type) {
          state.platformId = null
          return
        }
        const item = _this.platformList.filter(y => { return y.id === type })[0] || []
        const parentId = item.parent_id
        const showTypeList = ['商标服务', '版权服务', '专利服务']
        const listTest = item?.org?.split('>') || []
        // 判断是否'订单编号' : '商品编号'
        const res = listTest.filter(x => {
          return showTypeList.includes(x.trim())
        })
        if (res.length !== 0) {
          _this.labelName = '订单编号'
        } else {
           _this.labelName = '商品编号'
        }

        if (listTest[0].trim() === '易店无忧') {
          state.platformId = '1'
        } else {
          state.platformId = item.id
        }

        if (listTest[0].trim() === '江雀') {
          state.platformId = '江雀'
        }
        if (listTest[0].trim() === '鱼爪') {
          state.platformId = '鱼爪'
        }
        // if (parentId === 0) {
        //   state.platformId = item.id
        // } else {
        //   // methods.handleSelectPlatform(parentId)
        // }
      },

      // 验证下店业绩
      validateThree() {
        for (let i = 0; i < state.threeMonth.length; i++) {
          const item = state.threeMonth[i]
          if (!item.month) {
            return false
          }
          if (!item.money) {
            return false
          }
        }
        return true
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...initList(),
      ...uploadImg(),
      ...token(),
      ...methods,
      id
    }
  }
}
</script>
<style lang='less' scoped>
::v-deep .ant-upload img {
  width: 100%;
}
::v-deep .ant-upload-picture-card-wrapper {
  width: auto;
}
::v-deep .ant-upload.ant-upload-select-picture-card {
  margin-right: 0;
}
h3 {
  font-weight: bold;
}
.avatar-uploader {
  width: 100px;
  height: 100px;
}

.wrap {
  position: relative;
}

.dynamic-delete-button {
  position: absolute;
  left: calc(50% + 20px);
  top: 45px;
}
</style>
